import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  metaDataSelector,
  metaKeySelector,
  setMetaData,
  setMetaKey,
  setSuperBatches,
  superBatchesSelector,
} from 'features/superBatchManagement';
import { useUpdateMetaMutation } from 'services/superBatchService';
import styles from './SuperBatchUpdateMetaPage.module.scss';

function SubmitButton() {
  const dispatch = useDispatch();
  const metaKey = useSelector(metaKeySelector);

  const metaData = useSelector(metaDataSelector);
  const superBatches = useSelector(superBatchesSelector);

  const [updateMeta, { isSuccess, isLoading, error }] = useUpdateMetaMutation();

  const handleUpdate = useCallback(() => {
    const superBatchIds = superBatches.map((batch) => batch.value);
    const updateData =
      typeof metaData === 'object' ? { ...metaData } : metaData;

    if (
      (typeof updateData === 'object' &&
        Object.keys(updateData).length === 0) ||
      updateData === null
    ) {
      cogoToast.error('Please enter the required data for update.');
    } else {
      const updates = [{ [metaKey.value]: updateData }];
      updateMeta({ superBatchIds, updates });
    }
  }, [metaData, metaKey, superBatches, updateMeta]);

  const handleRemove = useCallback(() => {
    const superBatchIds = superBatches.map((batch) => batch.value);
    const updates = [{ [metaKey.value]: {} }];
    updateMeta({ superBatchIds, updates });
  }, [metaKey, superBatches, updateMeta]);

  const cleanup = useCallback(() => {
    dispatch(setSuperBatches([]));
    dispatch(setMetaKey({}));
    dispatch(setMetaData({}));
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Data updated successfully');
      cleanup();
    }
    if (error) cogoToast.error('Something went wrong.');
  }, [cleanup, dispatch, isSuccess, error]);

  useEffect(() => () => cleanup(), [cleanup]);

  return (
    <div className="row flex-ac">
      <Tappable
        className={classNames('btn btn-primary', styles.submit)}
        onClick={handleUpdate}
        disabled={isLoading || superBatches.length === 0 || metaKey === null}
      >
        Update Content
      </Tappable>
      <Tappable
        className={classNames('btn btn-secondary m-l-20', styles.submit)}
        onClick={handleRemove}
        disabled={isLoading || superBatches.length === 0 || metaKey === null}
      >
        Remove Content
      </Tappable>
    </div>
  );
}

export default SubmitButton;
